import { WebStorageStateStore } from "oidc-client-ts";
import type { UserManagerSettings } from "oidc-client-ts";

// 統一的 OIDC 配置
const baseConfig: Partial<UserManagerSettings> = {
  authority: "https://id.hle.com.tw",
  client_id: "js",
  response_type: "code",
  scope: "openid profile email",
  loadUserInfo: true,
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
};

export const teacherOidcConfig: UserManagerSettings = {
  ...baseConfig,
  authority: "https://id.hle.com.tw",
  client_id: "js",
  redirect_uri: `${window.location.origin}/teacher-callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silent-callback`,
  accessTokenExpiringNotificationTimeInSeconds: 60,
};

export const studentOidcConfig: UserManagerSettings = {
  ...baseConfig,
  authority: "https://id.hle.com.tw",
  client_id: "js",
  redirect_uri: `${window.location.origin}/student-callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silent-callback`,
  accessTokenExpiringNotificationTimeInSeconds: 60,
};